import { IIconProps } from '../interface';

const SvgSpain = ({ width = 56, height = 56 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 28C0 31.425 0.616109 34.7058 1.74158 37.7391L28 40.1739L54.2584 37.7391C55.3839 34.7058 56 31.425 56 28C56 24.575 55.3839 21.2942 54.2584 18.2609L28 15.8261L1.74158 18.2609C0.616109 21.2942 0 24.575 0 28H0Z"
      fill="#FFDA44"
    />
    <path
      d="M54.2585 18.2609C50.3023 7.59861 40.0391 0 28.0001 0C15.9611 0 5.6979 7.59861 1.7417 18.2609H54.2585Z"
      fill="#D80027"
    />
    <path
      d="M1.7417 37.7391C5.6979 48.4014 15.9611 56 28.0001 56C40.0391 56 50.3023 48.4014 54.2585 37.7391H1.7417Z"
      fill="#D80027"
    />
  </svg>
);

export default SvgSpain;
